export default __webpack_public_path__ + "static/Dirt-and-Rock-Removal-60e96a9747122ea46e03d32df9930743.jpg";